<template lang="pug">
.Layout
  .Layout-close
    button.Btn.BtnIcon(@click='closePopup')
      i.Icon.IconClose
  .Layout-header
    h2 {{ title }}
  .Layout-main
    .ExcelTable
      .ExcelTable-header.Actions
        .Actions-left.Sheets
          .Sheets-list(v-for='(sheet, index) in sheets')
            button.Btn(
              @click='selectSheet(index)',
              v-if='activeSheet !== index'
            ) {{ sheet.name }}
            button.Btn.Btn--blue(v-else) {{ sheet.name }}
        .Actions-right
          .ExcelFile-row-count-text(v-if='activeSheetRowCountText')
            | {{ activeSheetRowCountText }}
          .Actions-download(v-if='wb')
            button.Btn.Btn--transparent(@click='save')
              i.Icon.IconDownload
              span Выгрузить в xlsx

      .ExcelTable-table.Table(ref='table')
        vue-scrollbar.Scroll.Table-scroll(ref='scroll')
          table.Table-body(ref='bodyEl')
            tr.Table-row(
              v-for='row in tableRows',
              :ref='"row-" + row.id',
              :key='row.sheetIndex + "-" + row.id'
            )
              excel-cell(
                :ref='"col-" + index',
                :style='',
                v-for='(cell, index) in tableCols',
                :key='row.sheetIndex + "-" + row.id + "-" + index',
                :cell='tableData[row.id][index]'
              )
</template>

<script>
import * as ExcelJS from 'exceljs'

import ExcelCell from '@/components/objects/infrastructure/ExcelCell'
import VueScrollbar from '@/components/scrollbar/vue-scrollbar'

const MAX_ROW_COUNT = 100

export default {
  name: 'excel-file',

  props: {
    blob: {
      type: Blob
    },
    title: ''
  },

  components: {
    ExcelCell,
    VueScrollbar
  },

  data() {
    return {
      tableData: [],
      tableRows: [],
      tableCols: [],
      forceInput: '',
      scrollLeft: 0,
      scrollTop: 0,
      sheets: [],
      activeSheet: -1,
      tableWidth: 0,
      wb: null
    }
  },

  computed: {
    activeSheetRowCountText() {
      if (this.sheets.length === 0 || this.activeSheet < 0) {
        return ''
      }

      const activeSheet = this.sheets[this.activeSheet]
      if (activeSheet.actualRowCount < MAX_ROW_COUNT) {
        return ''
      }

      return `Отображается ${MAX_ROW_COUNT} из ${activeSheet.actualRowCount} строк`
    }
  },

  mounted() {
    this.handleImport()
  },

  methods: {
    closePopup() {
      this.$ui.popup.ok()
    },
    handleImport() {
      this.clearAllData()
      const wb = new ExcelJS.Workbook()
      const reader = new FileReader()

      reader.readAsArrayBuffer(this.blob)
      reader.onload = () => {
        const buffer = reader.result
        wb.xlsx.load(buffer).then((workbook) => {
          this.wb = workbook
          workbook.eachSheet((sheet, id) => {
            this.sheets.push(sheet)
          })
          this.selectSheet(0)
        })
      }
    },
    selectSheet(sheetIndex) {
      this.clearData()
      this.activeSheet = sheetIndex
      const sheet = this.sheets[sheetIndex]
      let width = 0
      for (let i = 0; i < sheet.columnCount; i++) {
        this.tableCols.push({
          name: sheet._columns[i].letter,
          width: (sheet._columns[i].width || 8.43) * 0.7
        })
        width += (sheet._columns[i].width || 8.43) * 0.7
      }

      this.tableWidth = width
      let realIndex = 1
      sheet.eachRow({ includeEmpty: false }, (row, rowIndex) => {
        const rowArray = []
        row.eachCell({ includeEmpty: true }, (cell) => {
          rowArray.push({
            value: cell.value && typeof cell.value === 'object' && (cell.value.formula || cell.value.sharedFormula) ? cell.value.result || '' : cell.value,
            name: cell.name,
            style: cell.style,
            color: cell.value && typeof cell.value === 'object' && (cell.value.formula || cell.value.sharedFormula) ? '#c8dcef' : '',
            isEditable: false
          })
        })

        if (realIndex <= MAX_ROW_COUNT) {
          this.tableData.push(rowArray)
          this.tableRows.push({
            id: realIndex - 1,
            sheetIndex: sheetIndex,
            size: row.height || 38
          })
        }

        realIndex++
      })

      if (this.$refs.scroll) {
        this.$refs.scroll.scrollToY(0)
        this.$refs.scroll.scrollToX(0)
        this.$refs.scroll.onResizeWindow()
      }
    },
    clearData() {
      this.tableData = []
      this.tableRows = []
      this.tableCols = []
      this.scrollLeft = 0
      this.scrollTop = 0
      this.active = [-1, -1]
      this.edit = [-1, -1]
    },
    clearAllData() {
      this.clearData()
      this.activeSheet = -1
      this.sheets = []
      this.wb = null
    },
    save() {
      this.wb.xlsx.writeBuffer().then((buffer) => {
        let blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const a = document.createElement('a')
        document.body.appendChild(a)
        a.style = 'display: none'
        const url = window.URL.createObjectURL(blob)
        a.href = url
        a.download = this.title + '.xlsx'
        a.click()
        window.URL.revokeObjectURL(url)
      })
    }
  }
}
</script>
<style lang="scss">
@import '~base';
#app .Layout,
.Popup .Layout {
  --popupSheetTabsColor: #{$white3};
  --tableBg: #{$grey7};
}

#app[data-theme='dark'] .Layout,
.Popup[data-theme='dark'] .Layout {
  --popupSheetTabsColor: #{$white3};
  --tableBg: #{$black4};
}
</style>
<style scoped lang="scss">
@import '~base';
.Layout {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  height: 100%;

  &-close {
    position: absolute;
    width: 48px;
    height: 48px;
    background: var(--borderColor);
    padding: 8px;
    top: 0px;
    right: 0px;
    text-align: center;
    z-index: 2000;
    .Icon {
      font-size: 14px;
    }
  }

  &-header {
    padding: 25px 30px 0;

    h2 {
      margin-bottom: 0;
      font-size: 16px;
      text-transform: uppercase;
    }
  }

  &-main {
    display: flex;
    flex: 1 1 auto;
    overflow: auto;
  }

  &-footer {
    flex: 0 0 50px;
    border-top: 1px solid var(--delimiter);
    padding: 7px 15px 0;

    button {
      margin-right: 17px;
      min-width: 283px;
    }
  }
}

.ExcelTable {
  display: flex;
  flex-direction: column;
  height: 100%;
  font-size: 13px;
  width: 100%;

  &-header {
    flex: 0 0 auto;
    padding: 15px;
  }

  &-table {
    flex: 1 1 auto;
  }
}

.Actions {
  display: flex;
  align-items: flex-start;

  &-left {
    flex: 1 1 auto;
  }
  &-right {
    flex: 0 0 auto;
    align-items: center;
    display: flex;
  }

  &-download {
    z-index: 10;
    margin: 5px 0;
  }

  &-download {
    button {
      color: $blue;
      font-size: 11px;
      text-transform: uppercase;
      line-height: 34px;
    }
  }
}

.Sheets {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  &-list {
    display: flex;

    button {
      min-width: 50px;
      margin: 5px 5px 5px 0;
      font-size: 11px;
      text-transform: uppercase;
      text-align: center;
      color: var(--popupSheetTabsColor);
    }

    button:not(.Btn--blue) {
      color: $blue;
    }
  }
}
.Table {
  position: relative;
  width: 100%;
  border: 1px solid transparent;
  overflow: hidden;

  &-scroll {
    width: 100%;
    height: 100%;
  }

  &-body {
    position: relative;
    width: 100%;
    padding: 1px;
  }

  &-main {
    position: relative;
    padding-left: 15px;
  }

  &-body {
    background: var(--tableBg);
  }
}

.ExcelFile {
  &-row-count-text {
    font-size: 14px;
    align-self: center;
    margin: 5px 16px 5px 0;
    line-height: 34px;
    color: var(--warningColor);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/ExcelFile.vue